package one.healthium.settings.ui.menu

import one.healthium.settings.domain.SettingsMenuModel

data class SettingsMenuUiState(
    val loading: Boolean = false,
    val menuId: String? = null,
    val menu: List<SettingsMenuModel>? = null,
)
